/**
 * RAD Truck Straps — rad-interactions.js
 * Scroll-reveal + animated stat counters
 * Drop-in Shopify asset. No dependencies. Dawn-compatible.
 *
 * INSTALL:
 *   1. Upload this file: Admin > Content > Files > Upload
 *   2. In theme.liquid, before </body>:
 *        {{ 'rad-interactions.js' | asset_url | script_tag }}
 *   3. Add class="rad-reveal" to any element you want to animate in on scroll.
 *   4. Add data-rad-count="1200" (target number) to any element you want to count up.
 *      Optional: data-rad-suffix=" lb" | data-rad-prefix="" | data-rad-duration="1400"
 *
 * USAGE EXAMPLES (paste into product descriptions or theme sections):
 *
 *   <div class="rad-reveal">Your content here</div>
 *
 *   <span class="rad-reveal" data-rad-count="1200" data-rad-suffix=" lb">1,200 lb</span>
 *
 *   Stagger children automatically:
 *   <ul class="rad-reveal-stagger">
 *     <li>Item one</li>
 *     <li>Item two</li>
 *   </ul>
 *
 * VARIANT CLASSES (add alongside rad-reveal):
 *   rad-reveal--up      fade up (default)
 *   rad-reveal--left    slide from left
 *   rad-reveal--right   slide from right
 *   rad-reveal--scale   scale in from 96%
 *   rad-reveal--fast    200ms duration
 *   rad-reveal--slow    800ms duration
 */

(function () {
  'use strict';

  /* ─── Guard: run once ─────────────────────────────────────── */
  if (window.__radInteractionsLoaded) return;
  window.__radInteractionsLoaded = true;

  /* ─── Constants ───────────────────────────────────────────── */
  var GOLD = '#c49426';
  var REVEAL_CLASS = 'rad-reveal';
  var STAGGER_CLASS = 'rad-reveal-stagger';
  var VISIBLE_CLASS = 'rad-visible';
  var COUNT_ATTR = 'data-rad-count';
  var SUFFIX_ATTR = 'data-rad-suffix';
  var PREFIX_ATTR = 'data-rad-prefix';
  var DURATION_ATTR = 'data-rad-duration';
  var DECIMALS_ATTR = 'data-rad-decimals';
  var DEFAULT_DURATION = 1400;
  var THRESHOLD = 0.18;

  /* ─── Inject base styles ──────────────────────────────────── */
  function injectStyles() {
    if (document.getElementById('rad-interactions-css')) return;
    var style = document.createElement('style');
    style.id = 'rad-interactions-css';
    style.textContent = [

      /* Base hidden state */
      '.rad-reveal{',
        'opacity:0;',
        'transition-property:opacity,transform;',
        'transition-timing-function:cubic-bezier(0.25,0.8,0.25,1);',
        'transition-duration:550ms;',
        'will-change:opacity,transform;',
      '}',

      /* Direction variants (default = up) */
      '.rad-reveal:not(.rad-reveal--left):not(.rad-reveal--right):not(.rad-reveal--scale){',
        'transform:translateY(28px);',
      '}',
      '.rad-reveal--left{transform:translateX(-32px);}',
      '.rad-reveal--right{transform:translateX(32px);}',
      '.rad-reveal--scale{transform:scale(0.96) translateY(12px);}',

      /* Speed variants */
      '.rad-reveal--fast{transition-duration:220ms;}',
      '.rad-reveal--slow{transition-duration:800ms;}',

      /* Visible state — all variants resolve to identity */
      '.rad-reveal.rad-visible{',
        'opacity:1;',
        'transform:none;',
      '}',

      /* Stagger: children get staggered delays */
      '.rad-reveal-stagger>*{',
        'opacity:0;',
        'transform:translateY(20px);',
        'transition:opacity 480ms cubic-bezier(0.25,0.8,0.25,1),',
                   'transform 480ms cubic-bezier(0.25,0.8,0.25,1);',
        'will-change:opacity,transform;',
      '}',
      '.rad-reveal-stagger.rad-visible>*{',
        'opacity:1;',
        'transform:none;',
      '}',

      /* Stagger child delays (up to 10 children) */
      (function(){
        var r='';
        for(var i=1;i<=10;i++){
          r+='.rad-reveal-stagger.rad-visible>*:nth-child('+i+'){transition-delay:'+((i-1)*80)+'ms;}';
        }
        return r;
      })(),

      /* Respect reduce-motion */
      '@media(prefers-reduced-motion:reduce){',
        '.rad-reveal,.rad-reveal-stagger>*{',
          'transition:opacity 200ms ease;',
          'transform:none!important;',
        '}',
      '}',

    ].join('');
    document.head.appendChild(style);
  }

  /* ─── Easing functions ────────────────────────────────────── */
  function easeOutQuart(t) {
    return 1 - Math.pow(1 - t, 4);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  /* ─── Stat counter ────────────────────────────────────────── */
  function animateCounter(el) {
    if (el.__radCounted) return;
    el.__radCounted = true;

    var target   = parseFloat(el.getAttribute(COUNT_ATTR));
    var suffix   = el.getAttribute(SUFFIX_ATTR) || '';
    var prefix   = el.getAttribute(PREFIX_ATTR) || '';
    var duration = parseInt(el.getAttribute(DURATION_ATTR), 10) || DEFAULT_DURATION;
    var decimals = parseInt(el.getAttribute(DECIMALS_ATTR), 10) || 0;

    /* Detect comma-formatted originals for locale formatting */
    var useLocale = /\d{1,3}(,\d{3})+/.test(el.textContent);

    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var elapsed  = timestamp - start;
      var progress = Math.min(elapsed / duration, 1);
      var eased    = easeOutQuart(progress);
      var current  = target * eased;

      var display;
      if (decimals > 0) {
        display = current.toFixed(decimals);
      } else if (useLocale) {
        display = Math.round(current).toLocaleString();
      } else {
        display = Math.round(current).toString();
      }

      el.textContent = prefix + display + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        /* Snap to exact target */
        if (decimals > 0) {
          el.textContent = prefix + target.toFixed(decimals) + suffix;
        } else if (useLocale) {
          el.textContent = prefix + target.toLocaleString() + suffix;
        } else {
          el.textContent = prefix + target.toString() + suffix;
        }
      }
    }

    requestAnimationFrame(step);
  }

  /* ─── Scroll-reveal observer ──────────────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      /* Graceful degradation: just show everything */
      var all = document.querySelectorAll('.' + REVEAL_CLASS + ', .' + STAGGER_CLASS);
      for (var i = 0; i < all.length; i++) {
        all[i].classList.add(VISIBLE_CLASS);
      }
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add(VISIBLE_CLASS);

        /* Fire counter if this element carries count data */
        if (el.hasAttribute(COUNT_ATTR)) {
          animateCounter(el);
        }

        /* Fire counters on any count children */
        var counters = el.querySelectorAll('[' + COUNT_ATTR + ']');
        counters.forEach(function (c) { animateCounter(c); });

        observer.unobserve(el);
      });
    }, {
      threshold: THRESHOLD,
      rootMargin: '0px 0px -40px 0px'
    });

    /* Observe all reveal elements */
    var reveals = document.querySelectorAll('.' + REVEAL_CLASS);
    reveals.forEach(function (el) { observer.observe(el); });

    /* Observe stagger wrappers */
    var staggerers = document.querySelectorAll('.' + STAGGER_CLASS);
    staggerers.forEach(function (el) { observer.observe(el); });

    return observer;
  }

  /* ─── Standalone counter observer ────────────────────────── */
  /* Catches counters not wrapped in rad-reveal */
  function initStandaloneCounters() {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.3 });

    var counters = document.querySelectorAll('[' + COUNT_ATTR + ']:not(.' + REVEAL_CLASS + ')');
    counters.forEach(function (el) { observer.observe(el); });
  }

  /* ─── RAD stat block auto-init ────────────────────────────── */
  /*
   * If the page contains elements with class "rad-stat-number",
   * this maps known RAD spec values automatically.
   * Markup: <span class="rad-stat-number" data-stat="break-strength"></span>
   *
   * Supported data-stat values:
   *   break-strength  → 1,200 lb
   *   wll             → 400 lb
   *   strap-length    → 9 ft
   *   bolt-size       → 10 mm
   *   tiktok-followers → 55,000
   *   instagram-followers → 81,000
   */
  var RAD_STATS = {
    'break-strength':       { count: 1200, suffix: ' lb', useLocale: true },
    'wll':                  { count: 400,  suffix: ' lb', useLocale: false },
    'strap-length':         { count: 9,    suffix: ' ft', useLocale: false },
    'bolt-size':            { count: 10,   suffix: ' mm', useLocale: false },
    'tiktok-followers':     { count: 55000, suffix: 'K', decimals: 0, useLocale: false,
                              transform: function(n){ return Math.round(n/1000); } },
    'instagram-followers':  { count: 81000, suffix: 'K', decimals: 0, useLocale: false,
                              transform: function(n){ return Math.round(n/1000); } },
  };

  function initRadStatBlocks() {
    var statEls = document.querySelectorAll('.rad-stat-number[data-stat]');
    if (!statEls.length) return;
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var key = el.getAttribute('data-stat');
        var spec = RAD_STATS[key];
        if (!spec || el.__radCounted) { observer.unobserve(el); return; }

        el.__radCounted = true;
        var target   = spec.count;
        var suffix   = spec.suffix || '';
        var prefix   = spec.prefix || '';
        var duration = parseInt(el.getAttribute(DURATION_ATTR), 10) || DEFAULT_DURATION;
        var xform    = spec.transform || function(n){ return n; };
        var useLocale = spec.useLocale !== false;
        var start = null;

        function step(ts){
          if(!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var current  = target * easeOutQuart(progress);
          var display  = useLocale
            ? Math.round(xform(current)).toLocaleString()
            : Math.round(xform(current)).toString();
          el.textContent = prefix + display + suffix;
          if(progress < 1){ requestAnimationFrame(step); }
          else {
            el.textContent = prefix + (useLocale
              ? xform(target).toLocaleString()
              : xform(target).toString()) + suffix;
          }
        }
        requestAnimationFrame(step);
        observer.unobserve(el);
      });
    }, { threshold: 0.3 });

    statEls.forEach(function(el){ observer.observe(el); });
  }

  /* ─── MutationObserver: catch late-rendered content ─────── */
  /* Handles Ajax cart, section re-renders, app injections */
  function initMutationWatcher(revealObserver) {
    if (!('MutationObserver' in window) || !revealObserver) return;

    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          /* New reveal elements */
          if (node.classList && node.classList.contains(REVEAL_CLASS)) {
            revealObserver.observe(node);
          }
          var newReveals = node.querySelectorAll
            ? node.querySelectorAll('.' + REVEAL_CLASS)
            : [];
          newReveals.forEach(function(el){ revealObserver.observe(el); });

          /* New counters */
          var newCounters = node.querySelectorAll
            ? node.querySelectorAll('[' + COUNT_ATTR + ']')
            : [];
          newCounters.forEach(function(el){ revealObserver.observe(el); });
        });
      });
    });

    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ─── Boot ────────────────────────────────────────────────── */
  function init() {
    injectStyles();
    var revealObserver = initReveal();
    initStandaloneCounters();
    initRadStatBlocks();
    initMutationWatcher(revealObserver);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();